import { paths } from "render/routes/paths";

// Manual check-in has no BankID/QR step, so identity is confirmed here, then
// preferred name is collected here too — this is the only check-in path that
// reaches the visit before it shows up in Active Sessions, where neither is
// asked again.
export function getSelectVisitConfirmUrl({
  patientId,
  visitId,
  newCheckInFlowEnabled,
}: {
  patientId: string;
  visitId: string;
  newCheckInFlowEnabled: boolean;
}): string {
  const confirmCheckInUrl = paths.selectVisitConfirm.url({
    patientId,
    visitId,
  });
  if (!newCheckInFlowEnabled) {
    return confirmCheckInUrl;
  }

  const preferredNameUrl = `${paths.preferredName.url({
    patientId,
    visitId,
  })}?returnPath=${encodeURIComponent(confirmCheckInUrl)}`;

  return `${paths.identityCheck.url({
    patientId,
    visitId,
  })}?returnPath=${encodeURIComponent(preferredNameUrl)}`;
}
